import type {
	StaffAccessResponse,
	StaffAccount,
	StaffSessionResponse,
} from "@play/shared";
import ky, { HTTPError } from "ky";

import { getApiBaseUrl } from "@/shared/api/config";

export type {
	PortalRole,
	StaffAccessResponse,
	StaffAccount,
	StaffSessionResponse,
	StaffTag,
} from "@play/shared";

const staffHttp = ky.create({
	prefixUrl: getApiBaseUrl(),
});

export async function loginStaff(
	email: string,
	password: string,
): Promise<StaffSessionResponse> {
	return staffHttp
		.post("auth/staff/login", { json: { email, password } })
		.json();
}

export async function refreshStaffSession(
	refreshToken: string,
): Promise<StaffAccessResponse> {
	return staffHttp
		.post("auth/staff/refresh", { json: { refreshToken } })
		.json();
}

export async function getStaffMe(accessToken: string): Promise<StaffAccount> {
	return staffHttp
		.get("auth/staff/me", {
			headers: { Authorization: `Bearer ${accessToken}` },
		})
		.json();
}

export async function readStaffLoginError(error: unknown): Promise<string> {
	if (error instanceof HTTPError) {
		if (error.response.status === 429) {
			return "Too many attempts";
		}
		try {
			const body = (await error.response.json()) as {
				code?: string;
				message?: string | string[];
				error?: string;
			};
			if (body.code) {
				return body.code;
			}
			if (Array.isArray(body.message)) {
				return body.message.join(", ");
			}
			if (typeof body.message === "string" && body.message.length > 0) {
				return body.message;
			}
			return body.error ?? error.message;
		} catch {
			return error.message;
		}
	}
	if (error instanceof Error) {
		return error.message;
	}
	return "Sign-in failed";
}
